var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoPins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "20px",
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VD",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dispatch-1",
    transform: "translate(-23.000000, -326.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico_pins",
    transform: "translate(20.000000, 324.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(4.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    stroke: "#FF5F00",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-1",
    points: "12.0003 16.0001 7.6003 16.0001 6.0003 17.6001 4.3993 16.0001 0.0003 16.0001 0.0003 4.0001 12.0003 4.0001"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-3",
    points: "16.0003 10.0001 16.0003 0.0001 6.0003 0.0001"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#FF5F00",
    points: "4.267 11.734 7.734 11.734 7.734 8.267 4.267 8.267"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPins);
export default __webpack_public_path__ + "static/media/ico_pins.8692bdc93e948cb36ec01e0775a19100.svg";
export { ForwardRef as ReactComponent };